import React, { Component } from "react";
import classNames from "classnames";
import axios from "axios";
import moment from "moment";
import db from "../../api/db";
moment.locale("nb");

class SearchMessages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: this.props.Date,
      job: [],
      working: true,
      lock: true,
      color: "grey"
    };

    this.bootJob = this.bootJob.bind(this);
    this.createJob = this.createJob.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.Date !== this.state.date) {
      this.setState(
        {
          date: props.Date
        },
        () => {
          this.searchQuery();
        }
      );
    }
  }

  componentDidMount() {
    this.searchQuery();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setAutoReload() {
    this.interval = setInterval(() => this.refresh(), 3000);
  }

  jobId() {
    const jobday = moment(this.state.date).format("DD");
    const jobmonth = moment(this.state.date).format("MM");
    return `${jobday}-${jobmonth}`;
  }

  setAlert(job) {
    const diff = moment().diff(job.last, "days");
    let color = "grey";
    if (diff > 50) {
      color = "yellow";
    }

    this.setState({
      color: color
    });
  }

  searchQuery() {
    if (moment(this.state.date).isValid()) {
      this.setState({
        working: true
      });

      db.get("job", this.jobId()).then(response => {
        const job = response.data;
        if (!job.done || job.inprogress) {
          this.setAutoReload();
        }
        this.setAlert(job);
        this.setState({
          job: job,
          working: false,
          lock: false
        });
      });
    }
  }

  refresh(repeat = false) {
    db.get("job", this.jobId()).then(response => {
      const job = response.data;
      if (job.done && !job.inprogress) {
        clearInterval(this.interval);
      }
      if (repeat) {
        this.setAutoReload();
      }
      this.setAlert(job);
      this.setState({
        job: job
      });
    });
  }

  bootJob() {
    this.setState({ lock: true });
    axios({
      method: "post",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      },
      url: "/api/operations/initjob/",
      data: {
        id: this.jobId()
      }
    })
      .then(response => {
        this.refresh(true);
      })
      .catch(err => {
        console.log(err);
      });
  }

  createJob(event) {
    event.preventDefault();
  }

  render() {
    let message;
    let action;
    const { job, lock, date, color, working } = this.state;

    if (!this.props.Display) {
      return <div></div>;
    }

    if (working || !date) {
      return (
        <div className={classNames("search-label", color)}>
          Arbeider...
        </div>
      );
    }

    if (typeof job === "object") {
      message =
        moment(date).format("D.MMMM") +
        " sist indeksert " +
        moment(job.last).format("D.M YYYY");
      action = (
        <button
          className="button mikro grey"
          disabled={!job.done || job.inprogress || lock}
          onClick={e => this.bootJob()}
        >
          {job.inprogress
            ? `Oppdaterer (${job.progress}%)`
            : !job.done
            ? "Oppdaterer (venter)"
            : "Oppdater"}
        </button>
      );
    } else {
      message =
        moment(date).format("D.MMMM") + " er ikke indeksert.";
    }

    return (
      <div className={classNames("search-label", color)}>
        {message}
        <span className="spacer"></span>
        {action}
      </div>
    );
  }
}

export default SearchMessages;
